import React from 'react';
import { Modal } from 'reactstrap-lib';
import type { ModalProps } from 'reactstrap-lib';
import { useModalZIndex } from '../shared/modalStack';

/**
 * Drop-in replacement for reactstrap Modal.
 * Automatically acquires a z-index from the global modal stack so the most
 * recently opened modal is always on top. If a zIndex prop is passed explicitly
 * it is used as-is and the modal still participates in the stack (so subsequent
 * modals open above it).
 */
const StackedModal: React.FC<ModalProps> = ({ isOpen, zIndex: zIndexProp, ...props }) => {
    const stackedZIndex = useModalZIndex(isOpen);
    const zIndex = zIndexProp !== undefined ? zIndexProp : stackedZIndex;
    return <Modal isOpen={isOpen} zIndex={zIndex} {...props} />;
};

export { StackedModal };
